/**
 * My subscriptions Dashboard Plugin — entry point and registration
 * (report-subscriptions spec, Req 2.1; FINN 3 / F3).
 *
 * Lists and manages the signed-in user's weekly and daily report digests. Visible to
 * every user while the REPORT_DIGEST_ENABLED flag is on (dashboardRegistry's
 * `visibleDashboardsFor` hides it otherwise); the resolvers only ever act on
 * the caller's own rows.
 */

import React from "react";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import type {
  DashboardPlugin,
  PluginDataResult,
  PluginFilterPanelProps,
} from "../../types";
import MySubscriptionsContent from "./MySubscriptionsContent";
import { MY_SUBSCRIPTIONS_DASHBOARD_ID } from "../../../publishedReports/reportSubscriptionModel";

const MySubscriptionsFilterPanel: React.FC<PluginFilterPanelProps> = () => null;

/** The content fetches its own data; the shell-level hook is inert (see publishedReports). */
const MY_SUBSCRIPTIONS_DATA: PluginDataResult = {
  data: {},
  isLoading: false,
  error: null,
  refetch: () => {},
};
const useMySubscriptionsData = (): PluginDataResult => MY_SUBSCRIPTIONS_DATA;

export const mySubscriptionsDashboard: DashboardPlugin = {
  id: MY_SUBSCRIPTIONS_DASHBOARD_ID,
  displayName: "My subscriptions",
  icon: <NotificationsNoneIcon />,
  description:
    "Weekly or daily email digests of the published reports you follow",

  FilterPanel: MySubscriptionsFilterPanel,
  ReportContent: MySubscriptionsContent,
  useData: useMySubscriptionsData,

  supportsComparison: false,
};
